module.exports = __webpack_public_path__ + "res/img_game_bg_t.7c505391592fbc9a2edb84ccf547875b.png";